import { ActionCards, CardType } from '../types';
export const PKG_NAME = '@axa-asia/aktivo-my-wellness-dashboard';

export const defaultActionCards: ActionCards = {
  step: [],
  exercise: [],
  lightActivity: [],
  sedentary: [],
  sleep: [],
};

export type ScopedStore = {
  errorMsgId: string;
  actionCardType?: CardType;
  actionCards?: ActionCards;
};

export const initialStore: ScopedStore = {
  errorMsgId: '',
  actionCards: defaultActionCards,
};

export type Store = {
  [PKG_NAME]: ScopedStore;
};
